module.exports = __webpack_public_path__ + "static/media/jason.15dadf84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/jason.jpg
// module id = 734
// module chunks = 0